@if (title() && title().trim()) {
<div class="d-flex justify-content-between align-items-center mb-4">
  <h5 class="mb-0 text-capitalize">{{ title() }}</h5>

  <!-- Actions slot (optional) -->
  <div class="d-flex align-items-center gap-2">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
} @if (showSearch()) {
<div class="row justify-content-end g-0" style="margin-bottom: 24px">
  <div class="col-12 col-sm-5 w-100">
    <form (ngSubmit)="onSearchSubmit()">
      <div class="input-group input-group-sm custom-search-group">
        <input
          class="form-control search"
          type="search"
          [placeholder]="'table.search' | translate"
          aria-label="Search"
          [value]="pendingTerm"
          (input)="onSearchInput($event)"
          (keydown.enter)="onSearchSubmit()"
          [disabled]="loading()"
        />
        <span
          class="input-group-text"
          role="button"
          tabindex="0"
          (click)="onSearchSubmit()"
          (keydown.enter)="onSearchSubmit()"
          aria-label="Submit search"
        >
          <i class="fa fa-search fs--1 text-600"></i>
        </span>
      </div>
    </form>
  </div>
</div>
}

<ag-grid-angular
  class="ag-theme-quartz custom-grid-theme"
  [style.width.%]="100"
  [style.height.px]="
    rowModelType() === 'infinite'
      ? gridHeight()
      : autoHeight()
      ? null
      : gridHeight()
  "
  [domLayout]="
    rowModelType() === 'infinite'
      ? 'normal'
      : autoHeight()
      ? 'autoHeight'
      : 'normal'
  "
  [rowHeight]="rowHeight()"
  [theme]="theme"
  [columnDefs]="columnDefs"
  [rowData]="rowModelType() === 'infinite' ? null : data()"
  [rowModelType]="rowModelType() || undefined"
  [cacheBlockSize]="cacheBlockSize()"
  [maxBlocksInCache]="maxBlocksInCache()"
  [quickFilterText]="quickFilter"
  (gridReady)="onGridReady($event)"
  [suppressClickEdit]="true"
  [suppressRowClickSelection]="true"
  [suppressCellFocus]="true"
  [enableCellTextSelection]="true"
  [attr.aria-busy]="loading() || null"
  [loading]="loading()"
  [suppressNoRowsOverlay]="loading()"
></ag-grid-angular>
